import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import { getBrand } from "@faire/help-center-utils/serialized-data/getBrand";
import getBrandIdv from "@faire/web-api/api/help-center/brand-verification/get";
var NO_BRAND_IDV_TOKEN = {
  field: "brandIdvToken",
  data: undefined
};
export var BrandIdvTokenDataFn = function BrandIdvTokenDataFn() {
  var _getBrand;
  var brandToken = (_getBrand = getBrand()) === null || _getBrand === void 0 ? void 0 : _getBrand.token;
  if (!brandToken) {
    return Promise.resolve(NO_BRAND_IDV_TOKEN);
  }
  return getBrandIdv().then(function (response) {
    var _response$brand_idv_r;
    return {
      field: "brandIdvToken",
      data: (_response$brand_idv_r = response.brand_idv_request) === null || _response$brand_idv_r === void 0 ? void 0 : _response$brand_idv_r.token
    };
  })["catch"](function () {
    return NO_BRAND_IDV_TOKEN;
  });
};